import styled from 'styled-components';

import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const DrawResponseIndividualPreview = styled.div`
  ${flexCentreAlignCss}
  height: 100%;
  width: 100%;
`;
